module.exports = __webpack_public_path__ + "img/take-photo.0d1fec68.jpg";